import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import "./styles/tailwind.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
	throw new Error("Trackerity dash: missing #root element in index.html");
}

createRoot(rootEl).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
